import { ref } from 'vue';
import { defineStore } from "pinia"
import api from '@/libs/axios'
import { ApiError } from '@/libs/axios';
import type { ApiResponse, ApiObject } from '@/libs/axios';
import type { Project } from '@/types/types';
//import { useAlertStore } from './alert-store';
export interface SMPObject {
    id : string
}


const KEYS = [
    'projects',
    'invoices',
    'customers',
   // 'postech',
    'rates',
    'piles',
    'climatic',
    'scopes',
    'users'
]

export const useCacheStore = defineStore('cache', () => {
    const cache = ref(new Map());
    const loading = ref(false);
    const error = ref(null);
    const ready = ref(false);

    async function initCache(){
       await Promise.all(KEYS.map(async (key) =>{
       // if(key != 'invoices' && key != 'postech'){
            await fetchAndWriteToCache(key,  `/${key}`);
       // }
       }));
        ready.value = true;

    }

    /**
     * read from the store cache (map)
     * @param cacheKey 
     * @returns Array of Objects
     */
    function getFromCache(cacheKey : string) : Array<SMPObject>{
        return cache.value.get(cacheKey);
    }

    /**
     * delete an item in a collection in the cache
     *
    function deleteItemFromCollectionById(cacheKey : string, id : string){
        const collection : Array<Object> = getFromCache(cacheKey);
    }*/

    /**
     * add a key,value to the cache
     * @param cacheKey 
     * @param val 
     */
    function addToCache(cacheKey : string, val : any){
        cache.value.set(cacheKey, val);
    }

    function clearCache(){
        cache.value = new Map();
    }

    /**
     * parse the projects if needed, there are some hacks here
     */
    async function parseProjects(array : Array<Project>){
        //set the project.engineer field to the project.invoices[].engineer
        array.forEach(proj =>{
            proj.invoices?.forEach(inv =>{
                inv['engineer'] = proj['engineer'];
            })
        })
    }

    /**
     * parse the individual project
     */
    async function parseProject(proj : Project){
         //set the project.engineer field to the project.invoices[].engineer
         proj.invoices?.forEach(inv =>{
            inv['engineer'] = proj['engineer'];
         })
    }

    /**
     * fetch from axios and write/overwrite entry in cache
     * @param cacheKey 
     * @param endpoint 
     * @returns Array of objects
     */
    async function fetchAndWriteToCache(cacheKey: string, endpoint : string) : Promise<Array<SMPObject>>{
        console.log("..fetchAndWriteToCache " + cacheKey + ' for endpoint :' + endpoint);
        //uses get
        loading.value = true;
        try{
            // const fetchedData = await apiWrapper.get(endpoint, apiWrapper.FORCE_FETCH);
            const resp : ApiResponse<Object> = await api.get(endpoint);
            //console.log("...resp = " + JSON.stringify(resp));
            const array : Array<SMPObject>  = resp.data.data[cacheKey]
            //console.log("....array = " + JSON.stringify(array));
            if(cacheKey === 'projects'){
                await parseProjects(array)
            }
            //const cacheKey = `data-${id}`;
            cache.value.set(cacheKey,array);
            loading.value = false;
            //console.log("...fetched and updated cache for " + cacheKey);
            return array;

        }catch(err){
            console.error("..cacheStore fetchAndWriteToCache error :" + err);
            loading.value = false;
            if(err instanceof ApiError){
                console.log(".post and update cache trapped APIerror" + err.message);
                throw err;
            }else{
                throw err;
            }
         
        }
        //loading.value = false;
        //console.log("...fetched and updated cache for " + cacheKey);
       // return [{ id : 'not found' }];
    }

    async function syncCacheWithApi(){
        console.log("..syncing browser cache with API...");
        loading.value = true;
        await Promise.all([
            KEYS.forEach(async (key) =>{
                await fetchAndWriteToCache(key, `/${key}`);
            })
        ])
        console.log("..cache synchronized with api");
        loading.value = false;
    }

    /**
     * post a new object to a cache, update cache
     */
    async function postAndUpdateCache(cacheKey : string, endpoint : string, obj : object, name : string) : Promise<SMPObject>{
        let resp : ApiResponse<typeof obj>;
        try{
            resp = await api.post(endpoint, obj);
        }catch(err){
            console.log("..error in posting to api...");
            if(err instanceof ApiError){
                console.log(".post and update cache trapped APIerror" + err.message);
                throw err;
            }else{
                throw err;
            }

        }
        //const resp = await api.post(endpoint, obj);
        if(resp){
            const added : SMPObject = resp.data.data[name];
            //TODO move this elsewhere
          /*  if(cacheKey === 'postech'){
                const projectsCollection : Array<Project> = cache.value.get('projects');
                const projIndex = projectsCollection.findIndex(proj =>{
                    return proj.id === added.projectId;
                })
                projectsCollection[projIndex].postech?.push(added);
                cache.value.set('projects', projectsCollection);
                //return added;

            }else if(cacheKey === 'invoices'){
                const projectsCollection : Array<Project> = cache.value.get('projects');
                const projIndex = projectsCollection.findIndex(proj =>{
                    return proj.id === added.projectId;
                })
                projectsCollection[projIndex].invoices?.push(added);
                cache.value.set('projects', projectsCollection);
                //return added;
*/
            if(cacheKey === 'projects'){
                //parse hack
                await parseProject(added);
            }
            const cachedCollection = cache.value.get(cacheKey);
           // console.log("cachedCollection type = ", typeof cachedCollection)
           // console.log("cachedCollection before = ", cachedCollection);
            cachedCollection.push(added);
           // console.log("cachedCollection after = ", cachedCollection);
            cache.value.set(cacheKey, cachedCollection);
           // console.log('1..postAndUpdateCache returning added = ' + JSON.stringify(added));
            return added;
        }else{
            return {id : 'not posted'};
        }


    }


    /**
     * put (update existing object) and, update cache
     */
    async function putAndUpdateCache(cacheKey : string, endpoint : string, obj : object, name : string) : Promise<SMPObject>{
        let resp : ApiResponse<typeof obj>;
        try{
            resp = await api.put(endpoint, obj);
         }catch(err){
            console.log("..error in puting to api...");
            if(err instanceof ApiError){
                console.log(".put and update cache trapped APIerror" + err.message);
                throw err;
            }else{
                throw err;
            }

        }
       // console.log(".RESP = " + JSON.stringify(resp));
      //  console.log("..field name = " , name);
      //  console.log("...resp.data.data.project : ", resp.data.data.project)
        if(resp){
            const updated : SMPObject = resp.data.data[name];    //TODO ensure API returns all graphFetched relations
            if(cacheKey === 'projects'){
                //parse hack
                await parseProject(updated);
            }
            const cachedCollection = cache.value.get(cacheKey);
        //    console.log("cachedCollection type = ", typeof cachedCollection)
        //    console.log("cachedCollection before = ", cachedCollection);
            const updatedCollection = cachedCollection.map(item =>{
                if(item.id === updated.id){
        //            console.log("...FOUND updated id in cachedCollection")
                }
               // console.log(".searching for match on id = " + updated.id);
               // console.log("..item" + JSON.stringify(item));
                return item.id === updated.id ? updated : item;
            }); 
       //     console.log("upatedCollection after " , updatedCollection);
            //cachedCollection.push(updated);
            cache.value.set(cacheKey, updatedCollection);
            return updated;
        }else{
            return { id : 'not put'};
        }
        

    }


    /**
     * delete an existing object and, update cache
     */
    async function deleteAndUpdateCache(cacheKey : string, endpoint : string, name : string) : Promise<SMPObject>{
        console.log("cacheStore.deleteAndUpdateCache()...endpoint : " + endpoint, " name : ", name, " cachekey = ", cacheKey);
        let resp : ApiResponse<Object>;
        try{
            resp = await api.delete(endpoint);
        }catch(err){
            console.log("..error in deleting from api...");
            if(err instanceof ApiError){
                console.log(".delete and update cache trapped APIerror" + err.message);
                throw err;
            }else{
                throw err;
            }

        }
        if(resp){
         //   console.log(".resp = " + JSON.stringify(resp));
            const deleted : SMPObject = resp.data.data[name];
         //   console.log(".deleted = " + JSON.stringify(deleted));

            //TODO move this elsewhere
            if(cacheKey === 'postech'){
                const projectsCollection : Array<Project> = cache.value.get('projects');
                const projIndex = projectsCollection.findIndex(proj =>{
                    return proj.id === deleted.projectId;
                })
            //    console.log("... deleted.id = " + deleted.id);
            //    console.log("....projIndex = " + projIndex);
            //    console.log("....cached project at index before postech delete= " + JSON.stringify(projectsCollection[projIndex]))
                const postechArr = projectsCollection[projIndex].postech?.filter(postech=>{
                    console.log("...proj postech.id = " + postech.id)
                    return postech.id != deleted.id;
                });
            //    console.log("...postechArr after filter = " + JSON.stringify(postechArr));
                projectsCollection[projIndex].postech = postechArr;
                cache.value.set('projects', projectsCollection);
            //    console.log("....cached project at index after postech delete= " + JSON.stringify(projectsCollection[projIndex]))
                //return added;

            }


            const cachedCollection = cache.value.get(cacheKey);
            //console.log("cachedCollection length before delete : " + cachedCollection.length);
            //console.log("..last entry:" + JSON.stringify(cachedCollection[cachedCollection.length-1]))
            //console.log("..cachedCollection before delete:" + JSON.stringify(cachedCollection));
            const objWithIdIndex = cachedCollection.findIndex((obj) => obj.id === deleted.id);
            //console.log("..objWithIdIndex = " + objWithIdIndex);
            if (objWithIdIndex > -1) {
                cachedCollection.splice(objWithIdIndex, 1);
            }
            //console.log("cachedCollection length after delete : " + cachedCollection.length);
            //console.log("..last entry:" + JSON.stringify(cachedCollection[cachedCollection.length-1]))
            //console.log("..cachedCollection after delete:" + JSON.stringify(cachedCollection));

            cache.value.set(cacheKey, cachedCollection);
            return deleted;
        }
        else{
            return { id : 'not deleted'}
        }

        
    }

    return{
        getFromCache,
        fetchAndWriteToCache,
        syncCacheWithApi,
        cache,
        loading,
        error,
        addToCache,
        postAndUpdateCache,
        putAndUpdateCache,
        deleteAndUpdateCache,
        clearCache,
        initCache,
        ready
    }
})